import { SCREENS } from "utils/constants";
import List from "./List";
import Detail from "./Detail";
import Open from "./Open";
import Replenish from "./Replenish";
import Convert from "./Convert";  
import Send from "./Send";

const routes = [
  {
    path: SCREENS.PRIVATE.XO.ACCOUNTS.LIST.path,
    exact: true,
    element: <List />,
  },
  {
    path: `${SCREENS.PRIVATE.XO.ACCOUNTS.DETAIL.path}/:id`,
    exact: true,
    element: <Detail />,
  },
  {
    path: SCREENS.PRIVATE.XO.ACCOUNTS.OPEN.path,
    exact: true,
    element: <Open />,
  },
  {
    path: SCREENS.PRIVATE.XO.ACCOUNTS.REPLENISH.path,
    exact: true,
    element: <Replenish />,
  },
  {
    path: SCREENS.PRIVATE.XO.ACCOUNTS.CONVERT.path,
    exact: true,
    element: <Convert />,
  },
  {
    path: SCREENS.PRIVATE.XO.ACCOUNTS.SEND.path,
    exact: true,
    element: <Send />,
  },
];

export default routes;
